<template>
  <div>
    <div class="header-container">
      <div class="header" data-aos="fade-down">
        <img
          src="@/assets/images/logo_2.png"
          alt=""
          class="logo"
          @click="$router.push({ path: '/' })"
        />
        <div
          style="display: flex; justify-content: center; align-items: center"
        >
          <div
            class="search"
            @click="goSearch"
            v-if="$route.fullPath !== '/search'"
          >
            <input type="text" placeholder="请输入关键词" />
            <img src="@/assets/images/search.png" alt="" />
          </div>
          <div class="wenjuan-box" @click="goLink">
            <img src="@/assets/images/index/diaochawenjuan.png" alt="" />
            <span>问卷调查</span>
          </div>
        </div>
      </div>
      <!-- {{ pageName }} -->
      <!-- 导航 -->
      <div class="nav-container" data-aos="fade-in">
        <div
          v-for="(item, index) in navList"
          :key="index"
          class="item"
          :class="{
            active: pageName
              ? item.pageName == pageName
              : index == currentParent,
            hasChild: Boolean(item.child),
          }"
        >
          <span class="text" @click="turnPage(item, index)">{{
            item.name
          }}</span>
          <div
            class="child-nav"
            v-if="item.child"
            :style="{
              paddingLeft: item.paddingLeft || '0',
            }"
          >
            <span
              class="child-item"
              v-for="(childItem, childIndex) in item.child"
              :class="{
                active:
                  (active(childItem.targetId) && index == currentParent) ||
                  (childItem.routerName &&
                    childItem.routerName == routerName) ||
                  (childItem.parentName && childItem.parentName == parentName),
              }"
              :key="childIndex"
              @click="goToSection(childItem)"
            >
              {{ childItem.name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CultureRouter from "@/router/culture.js";
import { getQuestionnaireReq } from "@/api/home";
export default {
  data() {
    return {
      currentParent: 0,
      url: "",
    };
  },
  computed: {
    navList() {
      return [
        {
          name: "首页",
          path: "/home",
        },
        {
          name: "导览",
          path: "/guide#section1",
          paddingLeft: "26%",
          child: [
            { name: "参观须知", targetId: "section1", parent: "/guide" },
            { name: "导览地图", targetId: "section2", parent: "/guide" },
            { name: "讲解服务", targetId: "section3", parent: "/guide" },
          ],
        },
        {
          name: "宣纸文化",
          paddingLeft: "26%",
          pageName: "culture",
          path: "/culture/name",
          child: this.CultureRouter.filter((item) => !item.hide),
        },
        {
          name: "展览",
          path: "/exhibition/list#0",
          paddingLeft: "38%",
          child: [
            { name: "全部", targetId: "0", parent: "/exhibition/list" },
            { name: "正在展览", targetId: "1", parent: "/exhibition/list" },
            { name: "历年展览", targetId: "2", parent: "/exhibition/list" },
          ],
        },
        {
          name: "藏品",
          path: "/collection/list#0",
          paddingLeft: "43%",
          child: [
            { name: "精品文物", targetId: "0", parent: "/collection/list" },
            { name: "馆藏文物", targetId: "1", parent: "/collection/list" },
            { name: "3D文物", targetId: "2", parent: "/collection/list" },
          ],
        },
        {
          name: "宣纸研究",
          path: "/study#zhuanzhu",
          paddingLeft: "54%",
          child: [
            { name: "专著", targetId: "zhuanzhu", parent: "/study" },
            { name: "期刊", targetId: "qikan", parent: "/study" },
            { name: "论文", targetId: "lunwen", parent: "/study" },
          ],
        },
        {
          name: "活动",
          path: "/education",
        },
        {
          name: "关于",
          path: "/about/dashiji",
          paddingLeft: "60%",
          child: [
            { name: "大事记", routerName: "dashiji", parent: "/about" },
            { name: "荣誉资质", routerName: "zizhi", parent: "/about" },
            { name: "周边景点", routerName: "xgjq", parent: "/about" },
          ],
        },
        {
          name: "留言板",
          path: "/messageBoard",
        },
      ];
    },
    pageName() {
      console.log("pageName", this.metaData.pageName);
      return this.metaData.pageName;
    },
    metaData() {
      return this.$route.meta || {};
    },
    routerName() {
      return this.$route.name;
    },
    parentName() {
      return this.metaData.parentName;
    },
    CultureRouter() {
      return CultureRouter.map((item) => {
        return {
          name: item.title,
          routerName: item.name,
          parentName: item.name,
          hide: item.hide,
        };
      });
    },
  },
  methods: {
    goLink() {
      if (this.url !== null && this.url !== undefined && this.url !== "") {
        window.open(this.url, "_blank");
      }
    },
    active(targetId) {
      return this.$route.hash.replace("#", "") === targetId;
    },

    turnPage(item, index) {
      if (this.$route.path == item.path) {
        return false;
      }
      if (item.path) {
        this.$router.push(item.path);
      }
    },
    goSearch() {
      if (this.$router.currentRoute.fullPath !== "/search") {
        this.$router.push({
          path: "/search",
        });
      }
    },
    updateActiveNav() {
      // 获取当前路由 path
      const currentPath = this.$route.path.split("/")[1].split("#")[0];
      // 遍历 navList，找到匹配项
      const foundIndex = this.navList.findIndex((item) => {
        // 确保 item.path 存在，并且拆分后包含 currentPath
        return (
          item.path &&
          (item.path.split("/").includes(currentPath) ||
            item.path.split("/")[1].split("#")[0].includes(currentPath))
        );
      });
      // 更新高亮索引
      this.currentParent = foundIndex !== -1 ? foundIndex : 0;
    },
    goToSection(item) {
      let { parent, targetId, routerName } = item;
      if (routerName) {
        this.$router.push({
          name: routerName,
        });
        return;
      }
      this.$router.push({ path: `${parent}#${targetId}` });
    },
  },

  watch: {
    $route: "updateActiveNav", // 监听路由变化
  },
  created() {
    this.updateActiveNav(); // 页面刷新时也要执行一次
    getQuestionnaireReq().then((res) => {
      this.url = res.result.linkUrl || "";
    });
  },
};
</script>
<style lang="scss" scoped>
.header-container {
  position: relative;
  width: 100%;
  //left: 0;
  //top: 0;
  background: #fff;
  z-index: 11;
  font-family: "PingFang SC";
}
.header {
  padding: 0 150px 0 123px;
  display: flex;
  justify-content: space-between;
  height: 104px;
  align-items: center;
  border-bottom: 1px solid #bbb;
  .logo {
    display: block;
    width: 560px;
    height: 48px;
  }
  .search {
    border: 1px solid #c6a669;
    border-radius: 20.5px;
    width: 310px;
    height: 41px;
    position: relative;
    input {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 20.5px;
      border: 0;
      font-size: 16px;
      padding: 0 40px 0 23px;
      box-sizing: border-box;
    }
    img {
      display: block;
      width: 21px;
      height: 22px;
      position: absolute;
      right: 22px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .wenjuan-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 34px;
    margin-top: 30px;
    img {
      width: 33px;
      height: 33px;
    }
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #c6a669;
    line-height: 36px;
    cursor: pointer;
  }
}
.nav-container {
  display: flex;
  justify-content: center;
  height: 55px;
  align-items: center;
  position: relative;
  .item {
    padding: 0 32px;
    cursor: pointer;
    height: 55px;
    line-height: 55px;
    position: relative;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    &.active {
      color: #c6a669;
      font-weight: 600;
    }

    &:hover .child-nav {
      display: block;
    }
    .child-nav {
      display: none;
      position: fixed;
      width: 100vw;
      height: 46px;
      left: 0;
      bottom: -45px;
      background: rgba(232, 232, 232, 0.6);
      background-size: 100% 100%;
      box-sizing: border-box;
      line-height: 45px;
      font-size: 16px;
      font-weight: 400;
      .child-item {
        padding: 0 20px;
        position: relative;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        cursor: pointer;
        &::before {
          content: "";
          display: block;
          width: 1px;
          height: 15px;
          background: #333;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
        &:nth-child(1)::before {
          display: none;
        }
        &.active {
          color: #c6a669;
          font-weight: 600;
        }
        &:hover {
          color: #c6a669;
          font-weight: 600;
        }
      }
    }
  }
  .hasChild:before {
    display: none;
    content: "";
    position: absolute;
    bottom: 1px; // 让箭头位于菜单上方
    left: 50%;
    transform: translateX(-50%);
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, 0.22) transparent; // 只显示下方的三角形
  }
  .hasChild:hover::before {
    display: block;
  }
}
</style>
